(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('DacContentController', DacContentController);

    DacContentController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];

	function DacContentController($scope, Principal, LoginService, $state) {

		
		$scope.tabData   = [
			{
                heading: 'Service',
                route:   'dac-content-main.nasrac-service',
                class: 'btn-lg'
            },
            {
                heading: 'Package',
                route:   'dac-content-main.nasrac-package',
                class: 'btn-lg'
            },
            {
                heading: 'Source',
                route:   'dac-content-main.nasrac-source',
                class: 'btn-lg'
            },
            {
              heading: 'Source Type',
              route:   'dac-content-main.nasrac-source-type',
              class: 'btn-lg'
            },
            {
                heading: 'Provider',
                route:   'dac-content-main.nasrac-provider',
                class: 'btn-lg'
            }
          ];
        
        $scope.go = function(route){
            $state.go(route);
        };
        
        
        $scope.go('dac-content-main.nasrac-service');

	}
})();
